import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {accountEntitlementConflictChecker} from 'src/openapi/admin/apis/AccountEntitlementsApi';
import {useAppDispatch} from 'src/store/hooks';

import type {EntitlementConflictRequest} from 'src/openapi/admin/models/EntitlementConflictRequest';

type Props = {
    accountId: number,
    entitlementConflictRequest: EntitlementConflictRequest,
};

export const useGetAccountEntitlementsConflicts = ({accountId, entitlementConflictRequest}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        accountEntitlementConflictChecker({accountId, entitlementConflictRequest}),
    ), [accountId, apiDispatch, entitlementConflictRequest]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
